import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
 
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

type Entity = models.ConfigContabilidadCuentasNotaCredito;

export interface Props {
    value: Entity;
    label: string;
    error?: kea.FieldError;
    onChange: (value: Entity) => PromiseLike<void> | void;
}

/**
* Valida un Entity
*/
export function validar(x: Entity) {
    const rules: validation.Rules<Entity> = {
        Iva: validation.required,
        RetencionIva: validation.required,
        Subtotal: validation.required,
        Total: validation.required
    };
    return validation.getErrors(rules, x);
}

/**
* Componente para editar un Entity
*/
export class CuentasPagoNotaDeCreditoComponent extends React.PureComponent<Props> {
    value = (props: Props) => props.value;
    errors = createSelectorRx(this.value, x => validar(x));
    hasError = createSelectorRx(this.errors, x => validation.hasError(x));
    getField = formfields(() => this.props, () => this.errors(this.props));

    render() {
        const { value } = this.props;
        const getField = this.getField;

        const Text = getField(kea.Text);

        return (
            <div>
                <kea.Panel title={this.props.label} error={this.props.error}>
                    <kea.Panel title={"Facturas Contado"}>
                        {kea.autogrid(3, [
                            <Text field="Subtotal" label="Subtotal (Abono)" />,
                            <Text field="Iva" label="IVA (Abono)" />,
                            <Text field="RetencionIva" label="Retención IVA (Cargo)" />,
                            <Text field="Total" label="Total (Cargo)" />,
                        ])}
                    </kea.Panel>
                    <kea.Panel title={"Facturas Credito"}>
                        {kea.autogrid(3, [
                            <Text field="SubtotalFacturasCredito" label="Subtotal (Abono)" />,
                            <Text field="IvaFacturasCredito" label="IVA (Abono)" />,
                            <Text field="RetencionIvaFacturasCredito" label="Retención IVA (Cargo)" />,
                            <Text field="TotalFacturasCredito" label="Total (Cargo)" />,
                        ])}
                    </kea.Panel>
                </kea.Panel>
            </div>);
    }
}



// WEBPACK FOOTER //
// ./app/features/general/configuraciones/edit/components/contabilidad/notasdecredito.tsx